import { Helmet } from "react-helmet-async";

const BRAND = "Immistop Global Migration Advisory";

export default function Seo({ title, description, jsonLd }) {
  const full = title ? `${title} | Immistop` : `${BRAND} | Private Immigration Advisory`;
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={full} />
      {description && <meta property="og:description" content={description} />}
      <meta name="twitter:title" content={full} />
      {description && <meta name="twitter:description" content={description} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
